// extracted by mini-css-extract-plugin
module.exports = {"container":"properties-buttons_container__p8EcB","active":"properties-buttons_active__372N_"};